<template src="./paymentExplanationModal.html"></template>

<script lang="ts">
    import { defineComponent } from 'vue';
    import { axiosRequests } from '../../../services/axiosinstance';
    import { editUrl } from '../../../services/helper';
    import { Routes } from '../../../const';
    import { Order } from '../../../models/Order';
    import PaymentExplanation from './PaymentExplanation.vue';

    interface ComponentModel {
        order: Order | null,
        isLoaded: boolean
    }

    export default defineComponent({
        name: 'PaymentExplanationModal',
        props: ["orderId"],
        components: { paymentExplanation: PaymentExplanation },
        data(): ComponentModel {
            return {
                order: null,
                isLoaded: false
            }
        },
        watch: {
            $route: function () {
                this.close();
            }
        },
        methods: {
            close: function () {
                this.$emit('close');
            },
            checkPressedButton: function (event: any) {
                if (event.keyCode == 27) this.close();
            },
            getOrder: async function () {
                await axiosRequests.get(editUrl(Routes.getOrder, this.orderId))
                    .then(
                        (data: Order) => {
                            this.order = data;
                            this.isLoaded = true;
                        }
                    )
                    .catch(
                        async (err: any) => {
                            this.isLoaded = true;

                            if (err.status == 401) {
                                return;
                            } else if (err.status == 403) {
                                this.$router.push('/forbidden');
                            } else if (err.status == 400 && err.data) {
                                this.$store.commit('SET_ADD_ERROR', err.data);
                            } else {
                                this.$store.commit('SET_ADD_ERROR', 'error.something_went_wrong');
                            }
                        }
                    );
            }
        },
        mounted() {
            window.addEventListener('keyup', this.checkPressedButton);

            this.getOrder();
        },
        beforeUnmount() {
            window.removeEventListener('keyup', this.checkPressedButton);
        }
    });
</script>

<style scoped>
    .payment_explanation_modal_wrapper {
        position: fixed;
        top: 0px;
        bottom: 0px;
        left: 0px;
        right: 0px;
        background-color: #b5b4b466;
        z-index: 9999;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .payment_explanation_modal_body {
        background-color: white;
        max-width: 560px;
        width: max-content;
        max-height: 80vh;
        overflow-y: auto;
        border-radius: 24px;
        animation: paymentExplanationModalShow 0.3s ease;
    }

    .payment_explanation_modal_title {
        font-size: 17px;
        letter-spacing: 1px;
        font-weight: 600;
        background-color: #f6f7f8;
        padding: 16px 24px;
        border-radius: 24px 24px 0px 0px;
    }

    .payment_explanation_modal_content {
        padding: 0px 24px;
    }

    .payment_explanation_modal_loading {
        color: #65656F;
    }

    .payment_explanation_modal_buttons_wrapper {
        margin-top: 12px;
        display: flex;
        padding: 0px 24px;
        margin-bottom: 8px;
    }

    @media(max-width: 500px) {
        .payment_explanation_modal_body {
            width: 98%;
        }
    }

    @keyframes paymentExplanationModalShow {
        0% {
            top: -100%;
        }

        100% {
            top: 50%;
        }
    }
</style>
